import { FC } from 'react';
import { useTypedDispatch, useTypedSelector } from '@/store/hooks';
import { creatorActions } from '@/store/slices/creatorSlice';
import { Modal, Button, Box } from '@mantine/core';
import { useContent } from '@/providers/ContentProvider';

const baseSlug = 'instructionModal.';

export const InstructionModal: FC = () => {
	const dispatch = useTypedDispatch();

	const { getContent } = useContent();

	const { options } = useTypedSelector((state) => state.creator);

	const handleClose = () => {
		dispatch(creatorActions.updateOptions({ instructionModalOpened: false }));
	};

	return (
		<Modal
			opened={options.instructionModalOpened}
			onClose={handleClose}
			title={getContent(`${baseSlug}title`)}
			size="xl"
		>
			<Box c="dimmed" mb="lg">
				{getContent('instructions.content')}
			</Box>
			<Button onClick={handleClose} mx="auto" color="black" size="md">
				{getContent(`${baseSlug}goToConfigurator`)}
			</Button>
		</Modal>
	);
};
